import * as bootstrap from 'bootstrap5'

window.bootstrap = bootstrap
